/* Hooks del cart drawer.
   Marca <html class="odis-drawer-open"> mientras el drawer está abierto, para
   poder ocultar widgets flotantes (chat, whatsapp) que suelen vivir en la
   esquina inferior derecha con z-index altísimo. Al cerrar, vuelven solos.
   Los selectores a ocultar se configuran en Configuración del tema →
   "🛒 Drawer Odis". */
(function () {
  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.odisHooked) return;
    drawer.dataset.odisHooked = '1';
    var sync = function () {
      document.documentElement.classList.toggle('odis-drawer-open', drawer.classList.contains('active'));
    };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
